import { createMachinePoolAtoms } from "@afar-research/client-runtime/state/machine-pool";

import { connectionAtomRuntime } from "./runtime";

export const machinePool = createMachinePoolAtoms(connectionAtomRuntime);
